import * as React from 'react';
const IconNavCollections = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 38 37"
    fill="none"
    style={{ width: '25px', height: '24px' }}
    {...props}
  >
    <path
      d="M0.830049 9.81511C0.371626 6.53326 2.66046 3.50118 5.94231 3.04275L21.783 0.830058C25.0648 0.371635 28.0969 2.66047 28.5553 5.94232L31.3638 26.0484C31.8222 29.3302 29.5334 32.3623 26.2516 32.8207L10.4109 35.0334C7.12907 35.4919 4.09698 33.203 3.63856 29.9212L0.830049 9.81511Z"
      fill="white"
    />
    <path
      d="M32.0005 3.81714C35.314 3.81737 38.0005 6.50455 38.0005 9.81812V30.1189C38.0005 33.4325 35.314 36.1187 32.0005 36.1189H24.3315L26.6665 35.7927C31.5889 35.105 35.0216 30.5569 34.3345 25.6345L31.5259 5.5271C31.443 4.93378 31.3027 4.36257 31.1138 3.81714H32.0005ZM27.8335 3.81714C28.1953 4.45585 28.4474 5.171 28.5552 5.94214L31.3638 26.0496L31.3989 26.3562C31.6689 29.4159 29.573 32.1929 26.5562 32.7712L26.2515 32.821L12.228 34.7791C10.8726 33.679 10.0054 32.0006 10.0054 30.1189V9.81714C10.0056 6.50373 12.6919 3.81727 16.0054 3.81714H27.8335Z"
      fill="white"
    />
  </svg>
);
export default IconNavCollections;
